var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

function ForecastWS(id, sessionId, queueId) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this);

  self = this;
  self.id = id;
  self.sessionId = sessionId;
  self.queueId = queueId;
  self.duration = ko.observable(null);
  self.name = 'ForecastWS';			// Convenience name for debugging
  self.units = ko.observable(null);
  self.serviceURL = ko.pureComputed(self._serviceURL.bind(self));
  return self;
};


ForecastWS.prototype = Object.create(AbstractWS.prototype);
ForecastWS.prototype.constructor = ForecastWS;


/**
 * Defines the string to request API services
 *
 * @returns {String}
 */
ForecastWS.prototype._serviceURL = function () {
  return '/qless/api/v1/employee/queues/' + self.id + '/forecast/next';
};


/**
 * Overload to prevent service from being called before the QueueID has been set
 *
 * @param {Function} fCallback
 * @returns none
 */
ForecastWS.prototype.doRequest = function (fCallback) {
  var self = this;
  self.reset();

  if (self.sessionId != -1 && self.queueId) {

    self.serviceURL = ko.computed(function () {
      return '/qless/api/v1/employee/queue/' + self.queueId + '/forecast/' + self.sessionId;
    });

    AbstractWS.prototype.doRequest.call(self, fCallback);
  }
};


/**
 * This method iterates over the data returned from the service and
 * converts the individual nodes into LocationModels and then assigns
 * them to this object's locations collection.
 *
 * @param {XMLString} xmlData XML data returned from the service
 * @returns {LocationsWS} Returns the object as chainable, for best practice
 */
ForecastWS.prototype.processData = function (xmlData) {
  var self = this;
  if (xmlData) {
    var json = xmlToJson.parse(xmlData);
    if (json) {
      var wait = (json.waitTimes) ? json.waitTimes.waitTime : null;

      if (!wait && json.waitTime) {
        wait = json.waitTime;
      }

      // Call the superclass method to perform any core actions
      AbstractWS.prototype.processData.call(self, xmlData);

      if (wait) {
        self.duration(Number(wait.duration));
        self.units(wait.units);
      }
    }
  }

  return self;
};


/**
 * Returns the object to it's initial state
 *
 * @returns none
 */
ForecastWS.prototype.reset = function () {
  var self = this;
  self.duration(null);
  self.units(null);
  // Call the superclass method to perform any core actions
  AbstractWS.prototype.reset.call(self);
};


module.exports = ForecastWS;
